import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { interceptorAvisouErro } from 'src/app/shared/http-interceptor/http-interceptor.module';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IPerfilAcesso, IFilterPerfilAcesso } from '../../models/role';
import { RolesService } from '../../services/roles.service';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-list-roles',
  templateUrl: './list-roles.component.html'
})
export class ListRolesComponent implements OnInit, OnDestroy {
  private listagemSub?: Subscription;

  ERoleAdminString = ERoleAdminString;
  totalDeItens = 0;
  paginaSelecionada = 0;
  quantidadeItensPorPagina = 10;

  totalPage = 0;

  roles: IPerfilAcesso[] = [];
  buscaControl = new FormControl('');

  constructor(
    private readonly roleService: RolesService,
    private readonly toastService: ToastService,
    private readonly sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.getList({
      active: true,
      pageNumber: this.paginaSelecionada,
      pageSize: this.quantidadeItensPorPagina
    });
  }

  getList(perfil: IFilterPerfilAcesso): void {
    const filtros: IFilterPerfilAcesso = {
      ...perfil
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    // Todo carregamento (busca, paginação, duplicar, deletar) mantém o termo digitado.
    const description = this.buscaControl.value?.trim();
    if (description) {
      filtros.description = description;
    }

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    // Cancela o carregamento anterior para uma resposta atrasada não sobrescrever a lista atual.
    this.listagemSub?.unsubscribe();
    this.listagemSub = this.roleService.carregarPerfil(filtros).subscribe({
      next: (resposta) => {
        this.roles = resposta.data;
        this.totalDeItens = resposta.count!;
        this.totalPage = Math.ceil(this.totalDeItens / this.quantidadeItensPorPagina);
      },
      error: (erro) => {
        if (!interceptorAvisouErro(erro)) {
          this.toastService.toast('Não foi possível carregar os perfis de acesso.', EMessageType.Error);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.listagemSub?.unsubscribe();
  }

  buscar(): void {
    this.mudouPagina(0);
  }

  limparBusca(): void {
    this.buscaControl.reset('');
    this.buscar();
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.paginaSelecionada = paginaSelecionada;

    const perfil = {
      active: true,
      pageNumber: this.paginaSelecionada,
      pageSize: this.quantidadeItensPorPagina
    };

    this.getList(perfil);
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.quantidadeItensPorPagina = itensPaginaSelecionada;

    const perfil = {
      active: true,
      pageNumber: 0,
      pageSize: this.quantidadeItensPorPagina
    };

    this.getList(perfil);
  }

  deletarRole(roleId: string): void {
    this.roleService.inativarRole(roleId).subscribe((resposta) => {
      if (resposta.messages && resposta.messages.length > 0) {
        this.toastService.toast(resposta.messages);
      }

      const perfil = {
        active: true,
        pageNumber: 0,
        pageSize: this.quantidadeItensPorPagina
      };

      this.getList(perfil);
    });
  }

  duplicarRole(roleId: string): void {
    this.roleService.duplicarRole(roleId).subscribe((resposta) => {
      if (resposta.messages && resposta.messages.length > 0) {
        this.toastService.toast(resposta.messages);
      }

      const perfil = {
        active: true,
        pageNumber: 0,
        pageSize: this.quantidadeItensPorPagina
      };

      this.getList(perfil);
    });
  }
}
